export default {
  title: 'Depurar',

  titles: {
    sendings: 'Último envío',
    textFields: 'g-text-field variantes',

    reset: {
      all: 'Reinicio completo',
      storage: 'Reinicio del almacenamiento',
      cache: 'Reinicio de las cachés',
      serviceWorker: 'Restauración del service worker',
      report: 'Resultado del reinicio'
    }
  },

  labels: {
    version: 'Versión de la plataforma',
    newVersion: 'Versión disponible',
    date: 'Fecha y hora',
    dateUTC: 'Fecha y hora UTC',
    timeZone: 'Zona horaria',
    utcOffset: 'Desfase UTC',
    locale: 'Idioma de la interfaz',
    viewport: 'Tamaño de la ventana',
    screen: 'Tamaño de la pantalla',
    pixelRatio: 'Densidad de píxeles',
    userAgent: 'User agent',
    standalone: 'Ejecución como PWA',
    host: 'Host',
    protocol: 'Protocolo',
    apiURL: 'Dirección de la API',
    socketURL: 'Dirección de WebSocket',
    route: 'Ruta',
    routeName: 'Nombre de la ruta',
    online: 'Red',
    connection: 'Tipo de conexión',
    cookieEnabled: 'Cookies',
    indexedDB: 'IndexedDB',
    caches: 'Cache Storage',
    storageUsage: 'Espacio ocupado en el almacenamiento',
    storageQuota: 'Cuota del almacenamiento',
    localStorageSize: 'Tamaño de localStorage',
    isLoggedAs: 'Sesión iniciada como usuario',

    ws: 'WebSocket',
    serviceWorker: 'Service worker',

    frontend: {
      title: 'Nombre de la plataforma'
    },

    browser: {
      name: 'Nombre',
      version: 'Versión'
    },

    account: {
      username: 'Nombre de usuario',
      balance: 'Balance',
      id: 'ID',
      reseller: 'ID del propietario',
      permissions: 'Cantidad de permisos',
      sendingTypes: 'Tipos de mensajes'
    },

    sending: {
      id: 'ID',
      recipient: 'Destinatario',
      type: 'Tipo de envío'
    },

    textFields: {
      outline: 'Outline mode',
      outlineLabel: 'Outline-label mode',
      lineLabel: 'Line-label mode'
    },

    reset: {
      socket: 'Conexión WebSocket',
      localStorage: 'localStorage',
      sessionStorage: 'sessionStorage',
      cookies: 'Cookies',
      serviceWorker: 'Service worker',
      cacheStorage: 'Cache Storage',
      indexedDB: 'IndexedDB'
    }
  },

  contents: {
    reset: {
      all: 'Se eliminarán el token, los ajustes, los favoritos, las cookies, las cachés y las bases de datos del navegador.<br>Una copia de localStorage se descarga en un archivo antes de la limpieza.<br><strong class="mt-2">¿Está seguro de que desea continuar?</strong>',
      storage: 'Se eliminarán el token, los ajustes, los favoritos y las cookies.<br>Una copia de localStorage se descarga en un archivo antes de la limpieza.<br><strong class="mt-2">¿Está seguro de que desea continuar?</strong>',
      cache: 'Se eliminarán las cachés y las bases de datos del navegador.<br>El token y los ajustes se conservan.<br><strong class="mt-2">¿Está seguro de que desea continuar?</strong>',
      serviceWorker: 'Se eliminarán los registros del service worker y las cachés del navegador.<br>El token, los ajustes y las bases de datos se conservan.<br>La página se cargará de nuevo.<br><strong class="mt-2">¿Está seguro de que desea continuar?</strong>'
    }
  },

  info: {
    download: {
      storage: '<strong>Copia de los datos guardados</strong><br>Guarda en un archivo el contenido del almacenamiento local - los datos que la plataforma conserva en este equipo. No se elimina ni se modifica nada.<br>Envíe el archivo al soporte si le piden detalles sobre el estado de la plataforma.'
    },

    reset: {
      serviceWorker: '<strong>Restauración del procesador en segundo plano</strong><br>Elimina el registro del procesador en segundo plano de la página y las copias guardadas de los archivos de la plataforma. El inicio de sesión, los ajustes y las bases de datos se conservan, la página se carga de nuevo y el procesador se registra otra vez.<br>Sirve cuando la plataforma se abre en una versión obsoleta o las actualizaciones no aparecen tras recargar la página.',
      cache: '<strong>Reinicio de las copias guardadas</strong><br>Elimina las copias guardadas de los archivos de la plataforma y sus bases de datos. El inicio de sesión y los ajustes se conservan, no hace falta volver a entrar. La página no se recarga sola, actualícela después del reinicio.<br>Sirve cuando las secciones muestran datos obsoletos o no se abren.',
      storage: '<strong>Reinicio del almacenamiento</strong><br>Elimina el inicio de sesión, los ajustes, los favoritos y los archivos de servicio del sitio, el idioma de la interfaz se conserva. Las copias guardadas de los archivos y las bases de datos se mantienen. Una copia del almacenamiento local se descarga en un archivo antes de la limpieza, tras el reinicio hará falta volver a entrar.<br>Sirve cuando la plataforma funciona de forma inesperada tras cambiar de cuenta o de ajustes.',
      all: '<strong>Reinicio completo</strong><br>Elimina todo lo que la plataforma conserva en este equipo: el inicio de sesión, los ajustes, los favoritos, los archivos de servicio del sitio, las copias guardadas de los archivos y las bases de datos, el idioma de la interfaz se conserva. Una copia del almacenamiento local se descarga en un archivo antes de la limpieza, tras el reinicio hará falta volver a entrar.<br>Último recurso cuando las demás vías no ayudaron.'
    }
  },

  reset: {
    done: 'Realizado',
    skipped: 'Omitido',
    failed: 'Error'
  },

  ws: {
    connected: 'Conectado',
    disconnected: 'Desconectado'
  },

  serviceWorker: {
    unsupported: 'No compatible con el navegador',
    unregistered: 'No registrado',
    installing: 'La actualización se está instalando',
    waiting: 'La actualización está descargada y espera aplicarse'
  },

  values: {
    yes: 'Sí',
    no: 'No',
    unavailable: 'No disponible'
  },

  buttons: {
    reset: {
      all: 'Reiniciar',
      storage: 'Reiniciar',
      cache: 'Reiniciar',
      serviceWorker: 'Restaurar'
    },

    download: {
      storage: 'Descargar'
    },

    clean: {
      storage: 'Limpiar almacenamiento'
    }
  }
}
